<template>
  <AdminSidePanel :title="plan ? `Editar plan · ${plan.name}` : 'Crear plan'" @close="$emit('close')">
    <form id="plan-form" @submit.prevent="submit">
      <p v-if="plan" class="ad-note">
        Los cambios aplican solo a nuevas asignaciones. Los parques que ya tienen este plan siguen pagando el precio con el que se les asignó.
      </p>
      <div class="ad-field">
        <label for="pl-name">Nombre del plan</label>
        <input id="pl-name" v-model="form.name" class="ad-input" maxlength="60" required autofocus />
      </div>
      <div class="ad-field">
        <label for="pl-price">Precio mensual (MXN)</label>
        <input id="pl-price" v-model="form.monthlyPrice" type="number" min="0" step="0.01" class="ad-input" required />
      </div>
      <div class="ad-field">
        <label for="pl-features">Funciones incluidas (una por línea)</label>
        <textarea id="pl-features" v-model="form.features" class="ad-textarea" rows="6" placeholder="Contratos y cobranza&#10;Portal del inquilino&#10;…"></textarea>
      </div>
      <div class="two">
        <div class="ad-field">
          <label for="pl-users">Máx. de usuarios</label>
          <input id="pl-users" v-model="form.maxUsers" type="number" min="1" step="1" class="ad-input" placeholder="Sin límite" />
        </div>
        <div class="ad-field">
          <label for="pl-plots">Máx. de naves</label>
          <input id="pl-plots" v-model="form.maxPlots" type="number" min="1" step="1" class="ad-input" placeholder="Sin límite" />
        </div>
      </div>
      <p class="ad-hint">Los límites son informativos por ahora: aún no se bloquea al parque que los rebase.</p>
      <p v-if="error" class="ad-error">{{ error }}</p>
    </form>
    <template #footer>
      <button type="button" class="ad-btn ad-btn--ghost" @click="$emit('close')">Cancelar</button>
      <button type="submit" form="plan-form" class="ad-btn ad-btn--primary" :disabled="busy">{{ busy ? 'Guardando…' : plan ? 'Guardar cambios' : 'Crear plan' }}</button>
    </template>
  </AdminSidePanel>
</template>

<script setup>
import { ref, reactive } from 'vue'
import AdminSidePanel from './AdminSidePanel.vue'
import { createPlan, updatePlan } from '@/services/superadmin'
import { errorText } from './adminFormat'

const props = defineProps({ plan: { type: Object, default: null } })
const emit = defineEmits(['close', 'done'])

const form = reactive({
  name: props.plan?.name || '',
  monthlyPrice: props.plan ? props.plan.monthlyPrice : '',
  features: (props.plan?.features || []).join('\n'),
  maxUsers: props.plan?.maxUsers ?? '',
  maxPlots: props.plan?.maxPlots ?? '',
})
const busy = ref(false)
const error = ref('')

async function submit() {
  busy.value = true
  error.value = ''
  const payload = {
    name: form.name,
    monthlyPrice: form.monthlyPrice,
    features: form.features.split('\n').map((l) => l.trim()).filter(Boolean),
    maxUsers: form.maxUsers === '' ? null : form.maxUsers,
    maxPlots: form.maxPlots === '' ? null : form.maxPlots,
  }
  try {
    if (props.plan) await updatePlan(props.plan.id, payload)
    else await createPlan(payload)
    emit('done')
  } catch (err) {
    error.value = errorText(err)
  } finally {
    busy.value = false
  }
}
</script>

<style scoped>
.two { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
</style>